export default "__VITE_ASSET__B$SmmOeB__"